import type {
  AppliedIntent,
  IntegerFilterInput,
} from '@moonpig/web-explore-types-graphql'
import type { SearchCriteria } from '@moonpig/web-shared-products'
import type { SearchFilter } from '../../../services'
import type { ApplicableFilter } from '../../../services/types/services'
import type { SearchContext } from '../shared'
import { mapFiltersToGroupedFilters } from '../../mappers'

export const createSearchCriteria = ({
  searchContext,
  integerFilter,
  preAppliedFilters,
  selectedFilters,
  appliedIntents,
}: {
  searchContext: SearchContext
  integerFilter: IntegerFilterInput | undefined
  preAppliedFilters: SearchFilter[]
  selectedFilters: ApplicableFilter[]
  appliedIntents?: AppliedIntent[]
}): SearchCriteria => ({
  searchTerm: searchContext?.searchTerm ?? /* istanbul ignore next */ '',
  filters: {
    integerFilter,
    groupedFacets: mapFiltersToGroupedFilters([
      ...preAppliedFilters,
      ...selectedFilters.map(f => ({ group: f.parent, key: f.id })),
    ]),
  },
  appliedIntents,
})
